export default "/server-build/img/2ef23e070069146068db4fb3bf804f78.png";